import { render, staticRenderFns } from "./shopsIndex.vue?vue&type=template&id=52bed626&scoped=true"
import script from "./shopsIndex.vue?vue&type=script&lang=js"
export * from "./shopsIndex.vue?vue&type=script&lang=js"
import style0 from "./shopsIndex.vue?vue&type=style&index=0&id=52bed626&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bed626",
  null
  
)

export default component.exports